<template>
  <div
    class="p-1 text-left fw-bold rounded border border-white"
    :style="`background-color: ${vehicle.backgroundColor ?? '#ffffff'}; color: ${vehicle.textColor ?? '#000000'};`"
    @dblclick="toggleHeight">
    <div class="d-flex justify-content-between">
      <div class="text-sm-secondary">
        <span class="fw-bolder">#{{ index + 1 }}.</span> {{ vehicle.plateNumber }}
        <span v-if="vehicle.hidden">(UKRYTY)</span>
        <div
          v-show="vehicle.comments.filter(c => !c.dateTime).length"
          class="fw-bolder notebook-btn text-xs"
          data-bs-toggle="modal"
          data-bs-target="#vehicleCommentModal"
          @click="launchVehicleCommentModal(vehicle)"
          role="button">
          NOTES {{ vehicle.comments.filter(c => !c.dateTime).length }}
        </div>
      </div>
      <div class="text-xl">
        <Popper placement="right">
          <span class="text-darker" role="button">
            <i class="fa-solid fa-ellipsis-vertical px-1"></i>
          </span>
          <template #content>

            <PlanComment style="text-align: center" :vehicle="vehicle"/>
            <br>

            <div
              class="text-sm my-2"
              data-bs-toggle="modal"
              data-bs-target="#rangePlanCommentModal"
              @click="launchRangePlanCommentModal(vehicle)"
              role="button">
              Zaplanuj wiele komentarzy
            </div>

            <CommentCreator :vehicle-id="vehicle.id" />
            <br>

            <div class="text-sm my-2" role="button" @click="ChangeVehicleVisibility(true)" v-if="!vehicle.hidden">Ukryj ciągnik</div>
            <div class="text-sm my-2" role="button" @click="ChangeVehicleVisibility(false)" v-else>Wyłącz ukrywanie ciągnika</div>

            <Popper placement="right" v-if="permissions.canUseAutomaticLabels">
              <div class="text-sm my-2" role="button">
                Etykiety automatyczne
              </div>
              <template #content>
                <form @submit.prevent="CreateAutomaticLabel">

                  <div class="form-group label_type">
                    <label>Typ etykiety</label>
                    <select class="form-control" v-model="labelType">
                      <option value="START">Etykieta START</option>
                      <option value="ZMIANA">Etykieta ZMIANA</option>
                    </select>
                  </div>

                  <div class="form-group">
                    <label>Data</label>
                    <input v-model="Label.date" type="date" class="form-control" placeholder="Data">
                  </div>

                  <div class="form-group">
                    <label>Godzina</label>
                    <input v-model="Label.time" type="time" class="form-control" placeholder="Godzina">
                  </div>

                  <button class="btn btn-primary mt-2" role="submit">
                    Dodaj etykietę
                  </button>

                </form>
              </template>
            </Popper>

            <br v-if="permissions.canUseAutomaticLabels">

            <router-link
              :to="{ name: 'VehicleEdit', params: { id: this.vehicle.id } }"
              class="text-sm my-2 text-decoration-none text-black"
              role="button"
            >
              Edycja pojazdu
            </router-link>
            <div class="text-sm mt-2 user-select-none" role="button">
              Kolor czcionki
              <div>
                <div class="colorsPallete">
                  <div class="mx-1 px-1 border border-1" role="button" style="background-color: #f8f9fa; display: inline;" @click="changeTextColor('#f8f9fa')"></div>
                  <div class="mx-1 px-1 border border-1" role="button" style="background-color: #47d147; display: inline;" @click="changeTextColor('#47d147')"></div>
                  <div class="mx-1 px-1 border border-1" role="button" style="background-color: #66FFFF; display: inline;" @click="changeTextColor('#66FFFF')"></div>
                  <div class="mx-1 px-1 border border-1" role="button" style="background-color: #ffff66; display: inline;" @click="changeTextColor('#ffff66')"></div>
                  <div class="mx-1 px-1 border border-1" role="button" style="background-color: #ff471a; display: inline;" @click="changeTextColor('#ff471a')"></div>
                  <div class="mx-1 px-1 border border-1" role="button" style="background-color: #ff9900; display: inline;" @click="changeTextColor('#ff9900')"></div>
                  <div class="mx-1 px-1 border border-1" role="button" style="background-color: #cccccc; display: inline;" @click="changeTextColor('#cccccc')"></div>
                  <div class="mx-1 px-1 border border-1" role="button" style="background-color: #3399FF; display: inline;" @click="changeTextColor('#3399FF')"></div>
                  <div class="mx-1 px-1 border border-1" role="button" style="background-color: #bf00ff; display: inline;" @click="changeTextColor('#bf00ff')"></div>
                  <div class="mx-1 px-1 border border-1" role="button" style="background-color: #222222; display: inline;" @click="changeTextColor('#222222')"></div>
                </div>
              </div>
            </div>
            <div class="text-sm mt-2 user-select-none">
              Kolor komórki
              <div>
                <div class="colorsPallete">
                  <div class="mx-1 px-1 border border-1" role="button" style="background-color: #f8f9fa; display: inline;" @click="changeBgColor('#f8f9fa')"></div>
                  <div class="mx-1 px-1 border border-1" role="button" style="background-color: #47d147; display: inline;" @click="changeBgColor('#47d147')"></div>
                  <div class="mx-1 px-1 border border-1" role="button" style="background-color: #66FFFF; display: inline;" @click="changeBgColor('#66FFFF')"></div>
                  <div class="mx-1 px-1 border border-1" role="button" style="background-color: #ffff66; display: inline;" @click="changeBgColor('#ffff66')"></div>
                  <div class="mx-1 px-1 border border-1" role="button" style="background-color: #ff471a; display: inline;" @click="changeBgColor('#ff471a')"></div>
                  <div class="mx-1 px-1 border border-1" role="button" style="background-color: #ff9900; display: inline;" @click="changeBgColor('#ff9900')"></div>
                  <div class="mx-1 px-1 border border-1" role="button" style="background-color: #cccccc; display: inline;" @click="changeBgColor('#cccccc')"></div>
                  <div class="mx-1 px-1 border border-1" role="button" style="background-color: #3399FF; display: inline;" @click="changeBgColor('#3399FF')"></div>
                  <div class="mx-1 px-1 border border-1" role="button" style="background-color: #bf00ff; display: inline;" @click="changeBgColor('#bf00ff')"></div>
                  <div class="mx-1 px-1 border border-1" role="button" style="background-color: #222222; display: inline;" @click="changeBgColor('#222222')"></div>
                </div>
              </div>
            </div>
          </template>
        </Popper>
      </div>
    </div>
  </div>
</template>

<script>
import Popper from 'vue3-popper'
import axios from 'axios'
import colors from '@/modules/cells/colors'
import Swal from 'sweetalert2'
import PlanComment from '@/components/PlanComment'
import emitter from '@/modules/events/emitter'
import CommentCreator from '@/components/TasksCalendar/Comments/Vehicle/CommentCreator.vue'
import eventKinds from '@/modules/events/eventKinds'
import { mapGetters } from 'vuex'

export default {
  name: 'VehicleCell',
  components: { CommentCreator, Popper, PlanComment },
  props: ['vehicle', 'isVerticallyExpanded', 'mailings', 'index'],
  data () {
    return {
      selectedCellColor: '#ffffff',
      selectedTextColor: '#000000',
      // comments: this.vehicle.comments,
      isCellExpanded: false,
      colors: colors,
      labelTitle: '',
      labelTextColor: '',
      labelBackgroundColor: '',
      comment: {
        title: '',
        content: '',
        FontCollor: '#000000',
        backgroundColor: '#ffffff'
      },
      Label: {
        title: '',
        type: '',
        date: '',
        time: ''
      },
      labels: [],
      labelType: 'START',
      hidden: this.vehicle.hidden,
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      permissions: 'permissionModule/getPermissions'
    })
  },
  created () {
    // emitter.on(eventKinds.vehicleCommentAdded, e => {
    //   if (e.vehicleId === this.vehicle.id) {
    //     this.reFetchVehicleComments()
    //   }
    // })
    // emitter.on(eventKinds.vehicleCommentDeleted, e => {
    //   if (e.vehicleId === this.vehicle.id) {
    //     this.reFetchVehicleComments()
    //   }
    // })
    // emitter.on(eventKinds.vehiclesPolled, this.reFetchVehicleComments)
  },
  methods: {
    launchVehicleCommentModal (vehicle) {
      emitter.emit(eventKinds.vehicleCommentModalRequested, { vehicle: vehicle })
    },
    launchRangePlanCommentModal () {
      emitter.emit(eventKinds.rangePlanCommentModalRequested, { vehicle: this.vehicle })
    },
    toggleHeight () {
      this.isCellExpanded = !this.isCellExpanded
    },
    handleNewLine (str) {
      return str.replace(/(?:\r\n|\r|\n)/g, '<br />')
    },
    ChangeVehicleVisibility (bool) {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      const putData = {
        hidden: bool
      }

      const sendRequest = (() => {
        axios.put(`${process.env.VUE_APP_API_BASE_URL}Vehicle/${this.vehicle.id}`, putData, config).then(() => {
          Swal.fire('Sukces', 'Pomyślnie wykonano zmianę', 'success')
        }).then(() => {
          this.hidden = bool
          emitter.emit('refreshed')
        })
      })

      if (this.vehicle.semiTrailer && this.vehicle.drivers.length > 0) {
        Swal.fire({
          title: 'Uwaga, przy ciągniku jest przypięta naczepa i kierowca!',
          text: '',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Tak, zmień widoczność',
          cancelButtonText: 'Nie, anuluj'
        }).then((result) => {
          if (result.value) {
            sendRequest()
          }
        })
      } else {
        sendRequest()
      }
    },
    CreateAutomaticLabel () {
      var date = ''
      if (this.Label.time === '') {
        date = this.Label.date
      } else {
        date = this.Label.date + 'T' + this.Label.time
      }

      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      const postData = {
        vehicleId: this.vehicle.id,
        Title: this.labelType,
        dateTime: date,
        TimeNotProvided: this.Label.time === ''
      }

      axios.post(process.env.VUE_APP_API_BASE_URL + 'Label/Automatic', postData, config)
        .then(response => {
          Swal.fire({
            title: 'Etykieta dodana',
            text: 'Etykieta została dodana',
            icon: 'success',
            type: 'success',
            confirmButtonText: 'OK'
          })

          emitter.emit('automaticLabelAdded')
        })
        .catch(error => {
          console.log(error)
          console.log(error.response.data)

          if (error.response.data === 'Cannot start new cycle if there are any labels after that!') {
            Swal.fire('Nie można rozpocząć nowego cyklu, jeśli po nim są jakieś etykiety!', '', 'info')
          }
        })
    },
    changeTextColor (Tcolor) {
      this.vehicle.textColor = Tcolor
      var myHeaders = new Headers()
      myHeaders.append('Content-Type', 'application/json')
      myHeaders.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`)
      var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      }
      fetch(`${process.env.VUE_APP_API_BASE_URL}Vehicle/${this.vehicle.id}`, requestOptions)
        .then(response => response.text())
        .then(result => {
          var myHeaders = new Headers()
          myHeaders.append('Content-Type', 'application/json')
          myHeaders.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`)
          const raw = JSON.stringify({
            textColor: Tcolor,
            backgroundColor: this.vehicle.backgroundColor,
            plateNumber: this.vehicle.plateNumber,
            name: this.vehicle.name,
            modifiTime: this.vehicle.modifiTime,
            communication: this.vehicle.communication,
            translatorTacho: this.vehicle.translatorTacho,
            mark: this.vehicle.mark,
            model: this.vehicle.model,
            year: this.vehicle.year,
            box: JSON.parse(result).box,
            tasks: this.vehicle.tasks ?? [],
            status: this.vehicle.status ?? 'Nie określono'
          })
          var requestOptions = {
            method: 'PUT',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
          }

          fetch(`${process.env.VUE_APP_API_BASE_URL}Vehicle/${this.vehicle.id}`, requestOptions)
            .then(response => response.text())
            .then(result => {
              document.querySelector('.box1').style = 'display: none;'
            })
            .catch(error => console.log('error', error))
        })
        .catch(error => console.log('error', error))
    },
    deleteComment (vehicleId, id) {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      axios.delete(process.env.VUE_APP_API_BASE_URL + 'Comment/' + id, config)
        .then(() => {
          emitter.emit(eventKinds.vehicleCommentDeleted, { vehicleId: vehicleId })

          Swal.fire({
            title: 'Komentarz usunięty',
            text: 'Komentarz został usunięty',
            icon: 'success',
            confirmButtonText: 'OK'
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
    changeBgColor (Bgcolor) {
      this.vehicle.backgroundColor = Bgcolor
      var myHeaders = new Headers()
      myHeaders.append('Content-Type', 'application/json')
      myHeaders.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`)
      var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      }
      fetch(`${process.env.VUE_APP_API_BASE_URL}Vehicle/${this.vehicle.id}`, requestOptions)
        .then(response => response.text())
        .then(result => {
          var myHeaders = new Headers()
          myHeaders.append('Content-Type', 'application/json')
          myHeaders.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`)
          const raw = JSON.stringify({
            textColor: this.vehicle.textColor,
            backgroundColor: Bgcolor,
            plateNumber: this.vehicle.plateNumber,
            name: this.vehicle.name,
            modifiTime: this.vehicle.modifiTime,
            communication: this.vehicle.communication,
            translatorTacho: this.vehicle.translatorTacho,
            mark: this.vehicle.mark,
            model: this.vehicle.model,
            year: this.vehicle.year,
            box: JSON.parse(result).box,
            tasks: this.vehicle.tasks ?? [],
            status: this.vehicle.status ?? 'Nie określono'
          })

          var requestOptions = {
            method: 'PUT',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
          }

          fetch(`${process.env.VUE_APP_API_BASE_URL}Vehicle/${this.vehicle.id}`, requestOptions)
            .then(response => response.text())
            .then(result => {
              // console.log(result)
              document.querySelector('.box1').style = 'display: none;'
            })
            .catch(error => console.log('error', error))
        })
        .catch(error => console.log('error', error))
    },
    async reFetchVehicleComments () {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      this.comments = (await axios.get(`${process.env.VUE_APP_API_BASE_URL}Vehicle/${this.vehicle.id}`, config)).data.comments
    }
  }
}
</script>

<style scoped>
.text-left {
  text-align: left;
}

.text-sm {
  font-size: .8rem;
}

.text-sm-secondary {
  font-size: .6rem;
}

.text-xs {
  font-size: .5rem;
}

.text-xl {
  font-size: 1.2rem;
}

.text-darker {
  color: #bbb;
}

.bg-light-green {
  background-color: #47d147;
}
.label_type {
 width: 300px;
}

.notebook-btn {
  cursor: pointer;
}
</style>
